export type UserStatus = 'Active' | 'Inactive';
export type UserRole = 'Admin' | 'User';

export enum NotificationType {
  MEETING_REMINDER = "meeting_reminder",
  MEETING_INVITATION = "meeting_invitation",
  MEETING_CANCELLED = "meeting_cancelled",
  MEETING_UPDATED = "meeting_updated",
  USER_MENTIONED = "user_mentioned",
  SYSTEM = "system"
}

export enum NotificationStatus {
  UNREAD = "unread",
  READ = "read",
  DISMISSED = "dismissed"
}

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  status: NotificationStatus;
  userId: string;
  meetingId?: string;
  data?: any;
  createdAt: string;
  readAt?: string;
  dismissedAt?: string;
}

export interface NotificationPreferences {
  emailNotifications: boolean;
  pushNotifications: boolean;
  meetingReminders: boolean;
  meetingInvitations: boolean;
  systemNotifications: boolean;
  reminderMinutes: number;
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  createdAt: string; // ISO string
  lastLoginAt?: string; // ISO string
  phoneNumber?: string;
  department?: string;
  position?: string;
  location?: string;
  avatarUrl?: string;
  notifications?: Notification[];
  notificationPreferences?: NotificationPreferences;
}

export interface NewUserInput {
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  phoneNumber?: string;
  department?: string;
  position?: string;
  location?: string;
  avatarUrl?: string;
  password: string;
}